module.exports = __webpack_public_path__ + "media/images/flags/4x3/bfa-1a7a4f33f3aac91183f2343c1cbfd4bb.svg";